document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('form.quick-add-inline').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      const items = [];
      form.querySelectorAll('tbody tr').forEach(function(row) {
        const qty = parseInt(row.querySelector('input[type="number"]').value);
        const id = row.querySelector('input[type="hidden"]').value;

        if (qty > 0) {
          items.push({ id: id, quantity: qty });
        }
      });

      if (items.length === 0) {
        alert('Por favor seleccioná al menos un talle.');
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Error al agregar al carrito');
        }
        return response.json();
      })
      .then(() => {
        // Si querés el Drawer, descomentá esto:
        // if (document.querySelector('cart-drawer')) {
        //   fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
        //     .then(response => response.json())
        //     .then(parsedState => {
        //       document.querySelector('cart-drawer').renderContents(parsedState);
        //     });
        //   return;
        // }

        // Si preferís un popup discreto, tipo notificación rápida:
        const notification = document.createElement('div');
        notification.textContent = 'Productos agregados al carrito';
        notification.style.position = 'fixed';
        notification.style.bottom = '20px';
        notification.style.right = '20px';
        notification.style.background = '#333';
        notification.style.color = '#fff';
        notification.style.padding = '10px 15px';
        notification.style.borderRadius = '5px';
        notification.style.zIndex = '9999';
        document.body.appendChild(notification);
        setTimeout(() => { notification.remove(); }, 3000);
      })
      .catch(error => {
        console.error('Error:', error);
        alert('Ocurrió un error al intentar agregar los productos.');
      });
    });
  });
});
